"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
const path = require("path");
const fs = require("fs");
const build_dep_graph_1 = require("./build-dep-graph");
const lockFileParser = require("snyk-nodejs-lockfile-parser");
const snyk_nodejs_lockfile_parser_1 = require("snyk-nodejs-lockfile-parser");
async function parse(root, targetFile, options) {
    const lockFileFullPath = path.resolve(root, targetFile);
    if (!fs.existsSync(lockFileFullPath)) {
        throw new Error('Lockfile ' + targetFile + ' not found at location: ' + lockFileFullPath);
    }
    const fullPath = path.parse(lockFileFullPath);
    const manifestFileFullPath = path.resolve(fullPath.dir, 'package.json');
    const shrinkwrapFullPath = path.resolve(fullPath.dir, 'npm-shrinkwrap.json');
    if (!fs.existsSync(manifestFileFullPath)) {
        throw new Error(`Could not find package.json at ${manifestFileFullPath} ` +
            `(lockfile found at ${targetFile})`);
    }
    if (fs.existsSync(shrinkwrapFullPath)) {
        throw new Error('Both `npm-shrinkwrap.json` and `package-lock.json` were found in ' +
            fullPath.dir +
            '.\n' +
            'Please run your command again specifying `--file=package.json` flag.');
    }
    const strictOutOfSync = options.strictOutOfSync !== false;
    const lockfileVersion = lockFileParser.getLockfileVersionFromFile(lockFileFullPath);
    if (lockfileVersion === snyk_nodejs_lockfile_parser_1.NodeLockfileVersion.YarnLockV1 ||
        lockfileVersion === snyk_nodejs_lockfile_parser_1.NodeLockfileVersion.YarnLockV2 ||
        lockfileVersion === snyk_nodejs_lockfile_parser_1.NodeLockfileVersion.NpmLockV2 ||
        lockfileVersion === snyk_nodejs_lockfile_parser_1.NodeLockfileVersion.NpmLockV3 ||
        lockfileVersion === snyk_nodejs_lockfile_parser_1.NodeLockfileVersion.PnpmLockV5 ||
        lockfileVersion === snyk_nodejs_lockfile_parser_1.NodeLockfileVersion.PnpmLockV6 ||
        lockfileVersion === snyk_nodejs_lockfile_parser_1.NodeLockfileVersion.PnpmLockV9) {
        return await (0, build_dep_graph_1.buildDepGraph)(root, manifestFileFullPath, lockFileFullPath, lockfileVersion, {
            includeDevDeps: options.dev || false,
            includeOptionalDeps: true,
            strictOutOfSync,
            pruneCycles: true,
            includeComponentMetadata: options.includeComponentMetadata || false,
        });
    }
    return lockFileParser.buildDepTreeFromFiles(root, manifestFileFullPath, lockFileFullPath, options.dev, strictOutOfSync, undefined, // honorAliases
    undefined, // showNpmScope
    options.includeComponentMetadata || false);
}
//# sourceMappingURL=index.js.map